import React from 'react';
import './Footer.scss';
import { FormattedMessage } from 'react-intl';

const Footer = () => {
  const disclaimerText = `Figures shown on this page are estimates based on data provided by third-parties. This material is provided for informational purposes only and should not be relied on for tax, legal, or financial advice. Neither J.D. Power® nor JEA provide tax, legal or financial advice. You should independently verify the estimates provided here before engaging in any transaction.`;

  return (
    <footer>
      <div className="Footer">
        <div className="container">
          <div className="disclaimer_container">
            <p>{disclaimerText}</p>
          </div>
          <p>
            <FormattedMessage
              id="footer.clientDisclaimer.jea"
              defaultMessage="© 2026 J.D. Power and its affiliates. All Rights Reserved."
              description="© 2026 J.D. Power and its affiliates. All Rights Reserved."
            />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
